import React from 'react';
import { RolesManagement } from 'pages/roles';
import { useUserRoleManagementData } from './useUserRoleManagementData';

export const UserRoleManagement: React.FC = () => {
  const {
    roles,
    organizations,
    permissions,
    isLoading,
    isError,
    isFetching,
    errorMessage,
  } = useUserRoleManagementData();
  return (
    <RolesManagement
      roles={roles}
      organizations={organizations}
      permissions={permissions}
      isLoading={isLoading}
      isError={isError}
      isFetching={isFetching}
      errorMessage={errorMessage}
    />
  );
};
